import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglehangoutsComponent } from './simple-icons-googlehangouts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglehangoutsComponent ],
    exports:      [ SimpleIconsGooglehangoutsComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglehangoutsModule {}
